import React, { useEffect, useState } from "react";
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useDispatch } from "react-redux";

// import Components
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { fetchDashboardAnalytics } from "../../slices/thunks";
import StaticView from "./StaticView";
import Statement from "./Statement";

const Widgets = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    dispatch(fetchDashboardAnalytics());
  }, [dispatch]);

  document.title = "Dashboard | " + process.env.REACT_APP_SITE_TITLE;

  return (
    <React.Fragment>
      <div className="page-content dashboard">
        <Container fluid>
          <BreadCrumb title="Dashboard" pageTitle="Dashboard" />

          <Nav tabs className="nav-tabs-custom nav-primary mt-sm-3 mb-3 dashboard-tabs">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={activeTab === "1" ? "active" : ""}
                onClick={() => {
                  toggleTab("1");
                }}
              >
                Static
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={activeTab === "2" ? "active" : ""}
                onClick={() => {
                  toggleTab("2");
                }}
              >
                Statement
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <StaticView />
            </TabPane>
            <TabPane tabId="2">
              <Statement />
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Widgets;

